<template>

    <div>

        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Title</h2>

        <div class="text-center">
            <div class="blocks-action-bar-inline">
                <div class="device-selector--large inline-style">

                    <i class="fas fa-desktop active" data-device="desktopSettings" v-b-tooltip.hover.top title="Desktop" @click="switchDevice"></i>
                    <i class="fas fa-tablet-alt" data-device="tabletSettings" v-b-tooltip.hover.top title="Tablet" @click="switchDevice"></i>
                    <i class="fas fa-mobile-alt" data-device="mobileSettings" v-b-tooltip.hover.top title="Phone" @click="switchDevice"></i>

                </div>
                
            </div>
        </div>

        <div class="preview-box" :style="{width : previewBoxWidth}">


            <component :is="style">

                .bundle-seo-title-link {
                    position: relative;
                }

                .bundle-seo-title-link a {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                }

                {{settingsFromWeebly.settings.titleTag === 'h2' ? 'body ': null}}#{{settingsFromWeebly.settings.titleId}} {
                    text-align: {{settingsFromWeebly.settings.buttonAlignement}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                    margin: {{settingsFromWeebly.settings.buttonMarginTop}}px auto {{settingsFromWeebly.settings.buttonMarginBottom}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};;
                    background-color: {{settingsFromWeebly.settings.buttonBg}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};;
                    padding: {{settingsFromWeebly.settings.buttonPaddingVertical}}px {{settingsFromWeebly.settings.buttonPaddingHorizontal}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};;
                    color: {{settingsFromWeebly.settings.textColor}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};;
                    text-decoration: none;
                    line-height: {{settingsFromWeebly.settings.lineHeight}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};;
                    font-size: {{settingsFromWeebly.settings.buttonTextFontSize}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    font-family: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontName : settingsFromWeebly.settings.fontFamily}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};;
                    font-style: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontStyle : settingsFromWeebly.settings.fontStyle}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};;
                    font-weight: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontWeight : settingsFromWeebly.settings.fontWeight}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};;
                    letter-spacing: {{settingsFromWeebly.settings.letterSpacing}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};;
                    
                    {{ settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent ?
                    'border-top-color:' + settingsFromWeebly.settings.borderTopColorParent+';' 
                    +'border-top-style:' + settingsFromWeebly.settings.borderTopStyleParent +';'
                    +'border-top-width:' + settingsFromWeebly.settings.borderTopWidthParent +'px;'

                    +'border-right-color:' + settingsFromWeebly.settings.borderRightColorParent +';'
                    +'border-right-style:' + settingsFromWeebly.settings.borderRightStyleParent +';'
                    +'border-right-width:' + settingsFromWeebly.settings.borderRightWidthParent+'px;'

                    +'border-bottom-color:'+ settingsFromWeebly.settings.borderBottomColorParent +';'
                    +'border-bottom-style: '+settingsFromWeebly.settings.borderBottomStyleParent+';'
                    +'border-bottom-width:' +settingsFromWeebly.settings.borderBottomWidthParent+'px;'

                    +'border-left-color:' +settingsFromWeebly.settings.borderLeftColorParent+';'
                    +'border-left-style:' +settingsFromWeebly.settings.borderLeftStyleParent+';'
                    +'border-left-width:' +settingsFromWeebly.settings.borderLeftWidthParent+'px;'
                    : ''}}

                    {{ !settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent ? 'border:' + settingsFromWeebly.settings.parentBorderWidth+'px ' + settingsFromWeebly.settings.parentBorderType+' ' + settingsFromWeebly.settings.parentBorderColor+';' : '' }}



                    border-radius: {{!settingsFromWeebly.settings.showBorderRadiusIndividual ?
                     settingsFromWeebly.settings.borderRadiusGlobal :
                      settingsFromWeebly.settings.borderRadiusLeftTop}}px {{!settingsFromWeebly.settings.showBorderRadiusIndividual ?
                     settingsFromWeebly.settings.borderRadiusGlobal :
                      settingsFromWeebly.settings.borderRadiusRightTop}}px {{!settingsFromWeebly.settings.showBorderRadiusIndividual ?
                     settingsFromWeebly.settings.borderRadiusGlobal :
                      settingsFromWeebly.settings.borderRadiusRightBottom}}px {{!settingsFromWeebly.settings.showBorderRadiusIndividual ?
                     settingsFromWeebly.settings.borderRadiusGlobal :
                      settingsFromWeebly.settings.borderRadiusLeftBottom}}px;
                    overflow: hidden;
                }
                #{{settingsFromWeebly.settings.titleId}} i {
                    font-size: inherit;
                }
                #{{settingsFromWeebly.settings.titleId}}.bundle-seo-title-link:hover{
                    background-color:  {{settingsFromWeebly.settings.buttonBgHover}};
                    color: {{settingsFromWeebly.settings.textColorHover}};
                    border-color: {{settingsFromWeebly.settings.borderColorHover}};
                }
                #{{settingsFromWeebly.settings.titleId}}.button-shadow-normal {
                    -webkit-box-shadow: {{settingsFromWeebly.settings.buttonShadowHorizontal}}px {{settingsFromWeebly.settings.buttonShadowVertical}}px {{settingsFromWeebly.settings.buttonBlurRadius}}px {{settingsFromWeebly.settings.buttonSpreadRadius}}px {{settingsFromWeebly.settings.buttonBoxShadowColor}};
                    box-shadow: {{settingsFromWeebly.settings.buttonShadowHorizontal}}px {{settingsFromWeebly.settings.buttonShadowVertical}}px {{settingsFromWeebly.settings.buttonBlurRadius}}px {{settingsFromWeebly.settings.buttonSpreadRadius}}px {{settingsFromWeebly.settings.buttonBoxShadowColor}};
                }
               
                @media(max-width: 768px) {
                    
                    #{{settingsFromWeebly.settings.titleId}} {
                        text-align: {{settingsFromWeebly.settings.buttonAlignementTablet || settingsFromWeebly.settings.buttonAlignement}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                        font-size: {{settingsFromWeebly.settings.buttonTextFontSizeTablet || settingsFromWeebly.settings.buttonTextFontSize}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                        letter-spacing: {{settingsFromWeebly.settings.letterSpacingTablet || settingsFromWeebly.settings.letterSpacing}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                        line-height: {{settingsFromWeebly.settings.lineHeightTablet || settingsFromWeebly.settings.lineHeight}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                        padding: {{settingsFromWeebly.settings.buttonPaddingVerticalTablet || settingsFromWeebly.settings.buttonPaddingVertical}}px {{settingsFromWeebly.settings.buttonPaddingHorizontalTablet || settingsFromWeebly.settings.buttonPaddingHorizontal}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                    }
                }
                @media(max-width: 576px) {
                  
                    #{{settingsFromWeebly.settings.titleId}} {
                        text-align: {{settingsFromWeebly.settings.buttonAlignementPhone || settingsFromWeebly.settings.buttonAlignementTablet || settingsFromWeebly.settings.buttonAlignement}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                        font-size: {{settingsFromWeebly.settings.buttonTextFontSizePhone || settingsFromWeebly.settings.buttonTextFontSizeTablet || settingsFromWeebly.settings.buttonTextFontSize}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                        letter-spacing: {{settingsFromWeebly.settings.letterSpacingPhone || settingsFromWeebly.settings.letterSpacingTablet || settingsFromWeebly.settings.letterSpacing}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                        line-height: {{settingsFromWeebly.settings.lineHeightPhone ||settingsFromWeebly.settings.lineHeightTablet || settingsFromWeebly.settings.lineHeight}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                        padding: {{settingsFromWeebly.settings.buttonPaddingVerticalPhone || settingsFromWeebly.settings.buttonPaddingVerticalTablet || settingsFromWeebly.settings.buttonPaddingVertical}}px {{settingsFromWeebly.settings.buttonPaddingHorizontalPhone || settingsFromWeebly.settings.buttonPaddingHorizontalTablet || settingsFromWeebly.settings.buttonPaddingHorizontal}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                    }
                }
            </component>

            <component :is="style" v-if="deviceStylesSetttings.tabletStyles">

                #{{settingsFromWeebly.settings.titleId}} {
                    text-align: {{settingsFromWeebly.settings.buttonAlignementTablet || settingsFromWeebly.settings.buttonAlignement}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                    font-size: {{settingsFromWeebly.settings.buttonTextFontSizeTablet || settingsFromWeebly.settings.buttonTextFontSize}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                    letter-spacing: {{settingsFromWeebly.settings.letterSpacingTablet || settingsFromWeebly.settings.letterSpacing}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                    line-height: {{settingsFromWeebly.settings.lineHeightTablet || settingsFromWeebly.settings.lineHeight}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                    padding: {{settingsFromWeebly.settings.buttonPaddingVerticalTablet || settingsFromWeebly.settings.buttonPaddingVertical}}px {{settingsFromWeebly.settings.buttonPaddingHorizontalTablet || settingsFromWeebly.settings.buttonPaddingHorizontal}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                }

            </component>

            <component :is="style" v-if="deviceStylesSetttings.mobileStyles">

                #{{settingsFromWeebly.settings.titleId}} {
                    text-align: {{settingsFromWeebly.settings.buttonAlignementPhone || settingsFromWeebly.settings.buttonAlignementTablet || settingsFromWeebly.settings.buttonAlignement}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                    font-size: {{settingsFromWeebly.settings.buttonTextFontSizePhone || settingsFromWeebly.settings.buttonTextFontSizeTablet || settingsFromWeebly.settings.buttonTextFontSize}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                    letter-spacing: {{settingsFromWeebly.settings.letterSpacingPhone || settingsFromWeebly.settings.letterSpacingTablet || settingsFromWeebly.settings.letterSpacing}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                    line-height: {{settingsFromWeebly.settings.lineHeightPhone ||settingsFromWeebly.settings.lineHeightTablet || settingsFromWeebly.settings.lineHeight}}{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                    padding: {{settingsFromWeebly.settings.buttonPaddingVerticalPhone || settingsFromWeebly.settings.buttonPaddingVerticalTablet || settingsFromWeebly.settings.buttonPaddingVertical}}px {{settingsFromWeebly.settings.buttonPaddingHorizontalPhone || settingsFromWeebly.settings.buttonPaddingHorizontalTablet || settingsFromWeebly.settings.buttonPaddingHorizontal}}px{{settingsFromWeebly.settings.titleTag === 'h2' ? '!important': null}};
                }

            </component>

            <component v-if="settingsFromWeebly.settings.linkTitle && globalSettings.elementGuidesOnlyDashboard" :is="settingsFromWeebly.settings.titleTag" :id="settingsFromWeebly.settings.titleId"
            class="bundle-seo-title"
            :class="settingsFromWeebly.settings.linkTitle ? 'bundle-seo-title-link' : null">

                <a 
                @click="preventClick" 
                :href="settingsFromWeebly.settings.buttonHref" :target="settingsFromWeebly.settings.buttonTarget" 
                ></a>

                <i v-if="settingsFromWeebly.settings.useIcon && settingsFromWeebly.settings.useIconBefore" :class="settingsFromWeebly.settings.iconClass" :style="{'margin-right':settingsFromWeebly.settings.iconMargin+'px'}"></i>

                <span v-html="settingsFromWeebly.settings.buttonText" contenteditable="true" @blur="updateItem"></span>   

                <i v-if="settingsFromWeebly.settings.useIcon && settingsFromWeebly.settings.useIconAfter" :class="settingsFromWeebly.settings.iconClass" :style="{'margin-left':settingsFromWeebly.settings.iconMargin+'px'}"></i>
            </component>

            <component v-if="settingsFromWeebly.settings.linkTitle && !globalSettings.elementGuidesOnlyDashboard" :is="settingsFromWeebly.settings.titleTag" :id="settingsFromWeebly.settings.titleId"
            class="bundle-seo-title"
            :class="settingsFromWeebly.settings.linkTitle ? 'bundle-seo-title-link' : null">

                <a 
                @click="preventClick" 
                :href="settingsFromWeebly.settings.buttonHref" :target="settingsFromWeebly.settings.buttonTarget" 
                ></a>

                <i v-if="settingsFromWeebly.settings.useIcon && settingsFromWeebly.settings.useIconBefore" :class="settingsFromWeebly.settings.iconClass" :style="{'margin-right':settingsFromWeebly.settings.iconMargin+'px'}"></i>

                <span v-html="settingsFromWeebly.settings.buttonText" contenteditable="false"></span>

                <i v-if="settingsFromWeebly.settings.useIcon && settingsFromWeebly.settings.useIconAfter" :class="settingsFromWeebly.settings.iconClass" :style="{'margin-left':settingsFromWeebly.settings.iconMargin+'px'}"></i>
            </component>

            <component v-if="!settingsFromWeebly.settings.linkTitle && globalSettings.elementGuidesOnlyDashboard" :is="settingsFromWeebly.settings.titleTag" :id="settingsFromWeebly.settings.titleId" class="bundle-seo-title">

                <i v-if="settingsFromWeebly.settings.useIcon && settingsFromWeebly.settings.useIconBefore" :class="settingsFromWeebly.settings.iconClass" :style="{'margin-right':settingsFromWeebly.settings.iconMargin+'px'}"></i>

                <span v-html="settingsFromWeebly.settings.buttonText" contenteditable="true" @blur="updateItem"></span>

                <i v-if="settingsFromWeebly.settings.useIcon && settingsFromWeebly.settings.useIconAfter" :class="settingsFromWeebly.settings.iconClass" :style="{'margin-left':settingsFromWeebly.settings.iconMargin+'px'}"></i>

            </component>

            <component v-if="!settingsFromWeebly.settings.linkTitle && !globalSettings.elementGuidesOnlyDashboard" :is="settingsFromWeebly.settings.titleTag" :id="settingsFromWeebly.settings.titleId" class="bundle-seo-title">

                <i v-if="settingsFromWeebly.settings.useIcon && settingsFromWeebly.settings.useIconBefore" :class="settingsFromWeebly.settings.iconClass" :style="{'margin-right':settingsFromWeebly.settings.iconMargin+'px'}"></i>

                <span v-html="settingsFromWeebly.settings.buttonText" contenteditable="false" @blur="updateItem"></span>

                <i v-if="settingsFromWeebly.settings.useIcon && settingsFromWeebly.settings.useIconAfter" :class="settingsFromWeebly.settings.iconClass" :style="{'margin-left':settingsFromWeebly.settings.iconMargin+'px'}"></i>

            </component>
           

        </div>

    </div>

</template>

<script>

export default {

    name: 'Title',

    data () {

        return {

            style: 'style'
            
        }
    },

    methods: {
        updateItem() {
            if(event.target.innerHTML == '') {
                event.target.innerHTML = 'Add Title'
            }
            this.$store.state.weeblySettings.settings.buttonText = event.target.innerHTML
            
        },

        preventClick() {
            event.preventDefault();
        },

        switchDevice(event) {

            // remove active class from possible elements
            const icons = document.querySelectorAll('.device-selector--large i');
            icons.forEach(icon => {
                console.log(icon)
                icon.classList.remove('active')
            })
            
            // add active class to current
            event.target.classList.add('active');

            console.log(event.target.dataset.device)

            // set active settings to true
            this[event.target.dataset.device] = true

            if(event.target.dataset.device === 'tabletSettings') {
                this.$store.state.previewBoxWidth = '768px'
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.tabletStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else if (event.target.dataset.device === 'mobileSettings') {
                this.$store.state.previewBoxWidth = '576px'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else {
                this.$store.state.previewBoxWidth = '100%'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.desktopStyles = true
            }

        }

    },

    computed: {

        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        },

        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        },

        globalSettings() {
            return this.$store.state
        }

    },

    components: {

        

    },
    
    mounted() {

        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active')

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../less/colors.less';
.bundle-seo-title {
    span {
        outline: none!important;
        display: inline-block;
        padding: 3px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/Title.vue